export const ERROR_REASONS = {
  NOT_FOUND: "NOT_FOUND",
  NO_DATA: "NO_DATA",
  UNAUTHORIZED: "UNAUTHORIZED",
};

export const ERROR_REFERENCE = {
  OFFER: "OFFER",
  BRAND: "BRAND",
};

export const NOT_FOUND_ERROR = new Error(ERROR_REASONS.NO_DATA);

export class NotFoundError extends Error {
  constructor(id) {
    super(`Resource with ${id} not found`);
    this.name = "NotFoundError";
  }
}

export class NoDataError extends Error {
  constructor() {
    super(`Data not found`);
    this.name = "NoDataError";
  }
}

export class UnauthorizedError extends Error {
  constructor() {
    super(`Unauthorized user`);
    this.name = "UnauthorizedError";
  }
}